export class RoomDTO {
	constructor(
		public id?: number,
		public name: string = 'new',
		public color: string = '#f8e29b',
		public examType: string = 'INPATIENT',
		public imagingCenterId?: number
	) {}
}
